// CSS math-range collector used by arithmetic evaluator.
// Example: protect expressions inside calc(...) from pre-evaluation.
import type { TextRange } from './types'
import { findMatchingPair } from './scanner-utils'

// Collect ranges for CSS math functions so internal expressions are not precomputed.
export function collectCssMathFunctionRanges(source: string): TextRange[] {
  // Return empty ranges when css math function names are absent.
  if (
    !source.includes('calc')
    && !source.includes('min')
    && !source.includes('max')
    && !source.includes('clamp')
  ) {
    return []
  } else {
    // Continue css math range scanning.
  }

  const ranges: TextRange[] = []
  // Regex finds `calc(`, `min(`, `max(`, and `clamp(` calls with optional spacing.
  const cssMathRegex = /\b(calc|min|max|clamp)\s*\(/g
  let match: RegExpExecArray | null = cssMathRegex.exec(source)

  // Walk each function call and map its parenthesis span.
  while (match) {
    const openParenOffset = match[0].lastIndexOf('(')
    const openParenIndex = match.index + openParenOffset
    const closeParenIndex = findMatchingPair(source, openParenIndex, '(', ')')
    // Skip malformed calls when closing parenthesis is missing.
    if (closeParenIndex !== -1) {
      ranges.push({ start: match.index, end: closeParenIndex + 1 })
    } else {
      // Keep scanning remaining css math matches.
    }

    match = cssMathRegex.exec(source)
  }

  // Return collected css math function ranges.
  return ranges
}

// Check if a source index belongs to one of the protected text ranges.
export function isIndexInsideRanges(index: number, ranges: TextRange[]): boolean {
  // Return true on the first range that contains the index.
  for (const range of ranges) {
    if (index >= range.start && index < range.end) {
      return true
    } else {
      // Continue range membership checks.
    }
  }

  // Return false when index is outside protected ranges.
  return false
}
